import {
  createDiscountRule,
  updateDiscountRule,
  deleteDiscountRule,
  getDiscountRule,
} from "backend/discount-rule";

/**
 * @typedef {Object} IDiscountRule
 * @type {object}
 * @property {string} appId
 * @property {string} suffixId
 * @property {string[]} productIds
 * @property {number} quantityFrom
 * @property {number | null} quantityTo
 * @property {"PERCENTAGE" | "FIXED_PRICE" | "FIXED_AMOUNT"} amountType
 * @property {number} amount
 * @property {string} startTimestamp
 * @property {string | null} endTimestamp
 */

export class DiscountRuleRepository {
  /**
   * @param {IDiscountRule} args
   * @returns {Promise<IDiscountRule>}
   */
  async create(args) {
    return createDiscountRule(args);
  }

  /**
   * @param {string} id
   * @returns {Promise<IDiscountRule>}
   */
  async findFirstById(id) {
    return (await getDiscountRule(id)) ?? null;
  }

  /**
   * @param {IDiscountRule} args
   * @returns {Promise<IDiscountRule>}
   */
  async update(args) {
    return updateDiscountRule(args);
  }

  /**
   * @param {string} id
   */
  async delete(id) {
    return deleteDiscountRule(id);
  }
}
